import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home'
import groupAdd from '@/views/group-add'
import login from '@/views/login'
import list from '@/views/list'
import accountList from '@/views/account-list'
import withdrawal from '@/views/withdrawal'
import withdrawalRecord from '@/views/withdrawal-record'
import userWithdrawalRecord from '@/views/user-withdrawal-record'
import accountLog from '@/views/account-log'
import my from '@/views/my'
import exchange from '@/views/exchange'
import links from '@/views/links'
import about from '@/views/about'
import bindAli from '@/views/bind-ali'
Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/join/group',
      name: 'groupAdd',
      component: groupAdd,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/taobao/exchange',
      name: 'exchange',
      component: exchange,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/links',
      name: 'links',
      component: links,
      meta: {
        // requireAuth:true,
      }
    },
    {
      path: '/list',
      name: 'list',
      component: list,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/accountLog',
      name: 'accountLog',
      component: accountLog,
      meta: {
        requireAuth: true
      }
    },

    {
      path: '/withdrawalRecord',
      name: 'withdrawalRecord',
      component: withdrawalRecord,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/userWithdrawalRecord',
      name: 'userWithdrawalRecord',
      component: userWithdrawalRecord,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/withdrawal',
      name: 'withdrawal',
      component: withdrawal,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/accountList',
      name: 'accountList',
      component: accountList,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/my',
      name: 'my',
      component: my,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/bindAli',
      name: 'bindAli',
      component: bindAli,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {
        requireAuth: true
      }
    },

    {
      path: '*',
      name: 'home',
      component: home,
      meta: {
        requireAuth: true
      }
    },

    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        isNomal: true
      }
    }

  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js